import { Component, ElementRef, ViewChild } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

@Component({
  selector: 'app-numeric-editor',
  templateUrl: './numeric-editor.component.html',
  styleUrls: ['./numeric-editor.component.scss']
})
export class NumericEditorComponent implements ICellEditorAngularComp {
  value: string = '';
 @ViewChild('cellInput') cellInput!: ElementRef<HTMLInputElement>;

  ngAfterViewInit() {
    setTimeout(() => {
      this.cellInput.nativeElement.focus();
      this.cellInput.nativeElement.select(); 
    });
  }
  agInit(params: ICellEditorParams): void {
    this.value = params.value || '';
  }

  getValue(): any {
    return this.value;
  }

  onKeyDown(event: KeyboardEvent) {
    // Allow digits, backspace, delete, arrows
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (
      !/^\d$/.test(event.key) &&
      !allowedKeys.includes(event.key)
    ) {
      event.preventDefault();
    }
  }
}
